import { getCashToClose } from 'graphql/cash-to-close/queries';
import { UseQueryOptions, useQuery } from 'react-query';

import { CashToCloseData } from './types';
import { getCashToCloseData } from './utls';

type CashToCloseReturn = {
  cashToCloseData: CashToCloseData;
  configuration: {
    transaction_type: string;
  };
};

type Params = {
  orderId: string;
  queryConfig?: UseQueryOptions<CashToCloseReturn, Error, CashToCloseReturn, any>;
};

export const useGetCashToClose = ({ orderId, queryConfig }: Params) =>
  useQuery(
    ['accounting-balance-cash-to-close', orderId],
    async () => {
      const response = await getCashToClose({ orderId });

      return {
        cashToCloseData: getCashToCloseData({
          accounting: response.getOrder.accounting,
          cashToCloseEntries: response.getOrder.cash_to_close,
        }),
        configuration: {
          transaction_type: response.getOrder.configuration.transaction_type,
        },
      };
    },
    {
      ...queryConfig,
      enabled: !!orderId && queryConfig?.enabled !== false,
      refetchOnWindowFocus: false,
    }
  );
